import React from 'react';
import { useRegistration } from './RegistrationContext';
import { useWebinarSlot } from './useWebinarSlot';
export const StickyBar = () => {
  const {
    openPopup
  } = useRegistration();
  const slot = useWebinarSlot();
  return <div className="fixed bottom-0 left-0 right-0 z-40 bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.1)]" data-id="element-394" data-mp="xth8yw985r32">
      <div className="max-w-3xl mx-auto px-4 py-2 text-center" data-id="element-395" data-mp="suw5mnyoerae">
        <p className="text-sm text-gray-700 mb-2" data-id="element-396" data-mp="nx473b3j06x8">
          {slot.dayPrefix} {slot.dateLabel} • {slot.time}
        </p>
        <button onClick={openPopup} className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition-colors text-base" data-id="element-397" data-mp="jty0u3geyfqr">
          GRATIS WEBINAR: Communiceren Met Je Hond
        </button>
      </div>
    </div>;
};